<template>
  <panel-main-template>
    <template v-slot:page-title>SMS</template>
    <template v-slot:page-content>
      <div class="sms--container">
        <div class="sms-list" v-if="data.length > 0">
          <div class="table--container">
            <div class="table--header">
              <div class="name">Клиент</div>
              <div class="number">Номер</div>
              <div class="text">Текст</div>
              <div class="date">Дата, время</div>
              <div class="status">Статус отправки</div>
            </div>
            <div class="table--rows">
              <div class="table--row" v-for="item in data" :key="item.id">
                <div class="name">{{item.clients?item.clients.name:'Клиент был удален или изменен номер телефона'}}</div>
                <div class="number">+{{item.number_to}}</div>
                <div class="text">{{item.text}}</div>
                <div class="date">{{dateTimeToRus(item.send_date)}}</div>
                <div class="status">{{item.status_text}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="data.length === 0 && requestCount > 0">
          <div class="alert alert-sm alert-info">
            Пока что не было отправлено ни одной СМС
          </div>
        </div>
        <div class="sms--pagination-container mrg-t-25">
          <paginator
              :pages="pagesCountPaginator"
              :now="thisPage"
              @setPage="setPage"
          ></paginator>
        </div>
      </div>
    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src
import userRepository from "../../repositories/user";
import PanelMainTemplate from "../../components/panel/MainTemplate";
import Paginator from "@/components/Paginator";
import Formatter from "../../components/libraries/Formatter";
const formatter = new Formatter();

export default {
  name: "Sms",
  components: {
    Paginator,
    PanelMainTemplate
  },
  data() {
    return {
      requestCount: 0,
      data: [],
      thisPage: 1, // Текущая страница
      pagesCountPaginator: 0, // Кол-во страниц
      pageSize: 25, // Сколько записей подгружать на 1 страницу
    };
  },
  watch: {

  },
  computed: {},
  methods: {
    dateTimeToRus(datetime){
      return formatter.phpDateTimeToShortString(datetime);
    },
    getData() {
      this.$store.dispatch("startPreloader");

      userRepository.getSmsLog({
        page: this.thisPage,
        page_size: this.pageSize
      }).then(resp => {
        this.data = resp.data.data;
        this.pagesCountPaginator = resp.data.pages;
        this.requestCount++;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    setPage(val) {
      this.thisPage = val;
      this.getData();
    },
  },
  metaInfo: {
    title: "СМС - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  created() {
    this.getData();
  }
};
</script>

<style scoped lang="less">
.stat{
  margin-bottom: 30px;
}
.sms--container{
  width: 100%;
}
.sms-list{
  overflow: auto;
}
.sms-item-sms:hover{
  background-color: #fafafa;
}
.sms-item-title{
  &>div{
    font-size: 13px;
    color: gray;
  }
}
</style>
